import React from "react";
import T from "prop-types";
import classNames from "classnames";
import * as F from "MODULES/shared/components/Forms/FormTypes";
import withFormFields, {
  withFormFieldsByKey
} from "MODULES/shared/decorators/withFormFields";
import {
  HEIGHT,
  LENGTH,
  NET_HEIGHT,
  NET_LENGTH,
  NET_WIDTH,
  WIDTH
} from "MODULES/parts/constants";
import { isEmpty } from "lodash";

function dimension(field, label, placeholder) {
  const { input, meta } = field;
  const hasError = meta.touched && meta.invalid;
  const classes = classNames("form-group", {
    "has-error": hasError
  });

  const errors =
    hasError &&
    meta.error.map(m => (
      <span className="help-block" key={m}>
        {m}
      </span>
    ));

  const onChange = e => {
    const val = isEmpty(e.target.value) ? null : e.target.value;
    input.onChange(val);
  };

  return (
    <div className="col-md-4">
      <div className={classes}>
        <label className="control-label sr-only" htmlFor={input.name}>
          {placeholder}
        </label>
        <input
          type="number"
          min="0"
          id={input.name}
          {...input}
          className="form-control"
          placeholder={placeholder}
          onChange={onChange}
          onBlur={onChange}
        />
        {errors}
      </div>
    </div>
  );
}

export function Dimensions({ length, width, height, required }) {
  return (
    <div className="form-group margin-bottom-none">
      <label className="control-label" htmlFor="dimensions">
        Dimensions (L&quot; &times; W&quot; &times; H&quot;)
        {required && <sup className="small text-danger">*</sup>}
      </label>
      <div id="dimensions" className="row row-col-gutters-half">
        {dimension(length, "Length", "L", required)}
        {dimension(width, "Width", "W", required)}
        {dimension(height, "Height", "H", required)}
      </div>
    </div>
  );
}

const Dimension = T.shape({
  input: F.stringInput.isRequired,
  meta: F.meta
});

Dimensions.propTypes = {
  length: Dimension.isRequired,
  width: Dimension.isRequired,
  height: Dimension.isRequired,
  required: T.bool
};

export default withFormFields(Dimensions, [LENGTH, WIDTH, HEIGHT]);

export const NetDimensions = withFormFieldsByKey(Dimensions, {
  [NET_LENGTH]: LENGTH,
  [NET_WIDTH]: WIDTH,
  [NET_HEIGHT]: HEIGHT
});



// WEBPACK FOOTER //
// ./app/modules/parts/components/shared/Dimensions.jsx